import { type FilterValues } from "components/filters/FilterContext";
import { mapAddressFilterToInstruction, mapAirportSizeFilterToInstruction, mapKeywordFilterToInstruction, mapResponseToAddressFilter, mapResponseToAirportSizeFilter, mapResponseToKeywordFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedAirportInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    address: mapAddressFilterToInstruction(filter.address),
    airportSize: mapAirportSizeFilterToInstruction(filter.airportSize),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListAirportFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  address: mapResponseToAddressFilter(response.address),
  airportSize: mapResponseToAirportSizeFilter(response.airportSize)
});